import { TextField, TextFieldProps } from "@mui/material";

interface CustomTextFieldProps extends Omit<TextFieldProps, "error"> {
  errorMessage?: string | false | undefined;
}

export default function CustomTextField({
  errorMessage,
  InputProps,
  ...props
}: CustomTextFieldProps) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      sx={{
        fontFamily: '"Lexend", sans-serif',
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          backgroundColor: "var(--neutral-50)",
          padding: "12px 14px",
          font: "var(--body-sm)",
          "& fieldset": {
            borderColor: "var(--neutral-200)",
          },
          "& placeholder": {
            color: "var(--neutral-400)",
          },
          "& .MuiInputBase-input": {
            padding: "0",
          },
        },
      }}
      error={!!errorMessage}
      helperText={errorMessage || ""}
      InputProps={{
        ...InputProps,
      }}
      {...props}
    />
  );
}
